import { Row, styled } from '@teko/ds-desktop';
import { RightOutlined } from '@teko/ds-icon';

interface IEnterAddressItemProps {
  placeHolder: string;
  valueInput: string;
  onClick: () => void;
  disabled: boolean;
}

export const EnterAddressItem = ({
  placeHolder,
  valueInput,
  onClick,
  disabled,
}: IEnterAddressItemProps) => {
  return (
    <Wrapper
      onClick={() => {
        if (disabled) {
          return;
        }
        onClick();
      }}
    >
      <Row align="middle" justify="space-between">
        <StyledPlaceHolder isHasValue={!!valueInput}>
          {valueInput || placeHolder}
        </StyledPlaceHolder>
        <RightOutlined size={15} />
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  cursor: pointer;
`;

const StyledPlaceHolder = styled.p<{ isHasValue: boolean }>(
  ({ theme, isHasValue }) => `
    font-size: 13px;
    font-weight: 400;
    color: ${isHasValue ? theme.colors.textTitle : theme.colors.placeholder}
`,
);
